import { PRNG } from "./PRNG";

const { cos, sin, min, max, sqrt, PI, pow } = Math;

export const RAD = PI / 180;
export const DEG = 180 / PI;

export function R(a = null, b = null) {
  if (a == null) return PRNG.random();
  if (Array.isArray(a)) return a[~~(PRNG.random() * a.lengt)];
  if (b == null) return R(0, a);
  return a + PRNG.random() * (b - a);
}

export function gain(x, k = 4) {
  let a = 0.5 * pow(2.0 * (x < 0.5 ? x : 1.0 - x), k);
  return x < 0.5 ? a : 1.0 - a;
}

export function smoothstep(a, b, x) {
  return lerp(catmull(x), a, b);
}

export function catmull(t) {
  return t * t * (3 - 2 * t);
}

export function lerp(t, a, b) {
  return a * (1 - t) + b * t;
}

export function norm(t, a, b) {
  return (t - a) / (b - a);
}

export function remap(t, a0, b0, a1, b1) {
  return lerp(norm(t, a0, b0), a1, b1);
}

export function clamp(t, mi, ma) {
  return min(ma, max(mi, t));
}

export function distance(v1, v2) {
  return sqrt(squareDistance(v1, v2));
}

export function squareDistance(v1, v2) {
  const dx = v2.x - v1.x;
  const dy = v2.y - v1.y;
  return dx * dx + dy * dy;
}

// query string
const booleanTrue = [true, "true", "yes"];
const booleanFalse = [false, "false", "no"];
const booleans = booleanTrue.concat(booleanFalse);

export function getQueryVariable(variable) {
  const urlParams = new URLSearchParams(window.location.search);

  variable = variable.replace(/[\[\]]/g, "\\$&");
  let value = urlParams.get(variable);

  //not set
  if (value == null) return null;
  if (value == "") return null;

  //boolean
  if (booleans.indexOf(value) != -1) {
    if (booleanTrue.indexOf(value) != -1) {
      return true;
    }
    if (booleanFalse.indexOf(value) != -1) {
      return false;
    }
  }

  //string or object
  if (isNaN(parseFloat('"' + value + '"'))) {
    value = value.trim();

    //try to parse an object
    if (value.charAt(0) === "{") {
      value = JSON.parse(value);
    }

    return value;
  }

  //int
  if (value.lastIndexOf(".") == -1) return parseInt(value);

  //float
  return parseFloat(value);
}

// TODO encode blob to string

export function setQueryVariable(variable, value) {
  if ("URLSearchParams" in window) {
    var searchParams = new URLSearchParams(window.location.search);
    searchParams.set(variable, value);
    var newRelativePathQuery =
      window.location.pathname + "?" + searchParams.toString();
    history.pushState(null, "", newRelativePathQuery);
  }
}
export function getAlQueryVariables(obj = {}) {
  const urlParams = new URLSearchParams(window.location.search);
  for (const [key, value] of urlParams.entries()) {
    obj[key] = getQueryVariable(key);
  }
  return obj;
}
